import React from 'react';

const ProgressBar = () => (
  <div className="progress-bar-container">
    <div className="progress-bar" />
  </div>
);

export default ProgressBar;
